module.exports = __webpack_public_path__ + "img/info.e7ee1e70.svg";